/* ============================================================================
   Meter Boxes Now — theme behaviour.
   Vanilla JS only. No jQuery, no external CDN scripts, no third-party widgets.
   Every feature here is a progressive enhancement over markup that already
   works with JavaScript disabled.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.documentElement;

  /* -- persistence -------------------------------------------------------- */
  function persist(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
    document.cookie = key + '=' + encodeURIComponent(value) + ';path=/;max-age=31536000;samesite=lax';
  }

  /* -- audience mode ------------------------------------------------------ */
  /* Both menu trees and both content variants are already in the DOM. This
     only changes which is visible, so there is no fetch and no layout shift. */
  function setAudience(mode) {
    if (mode !== 'residential' && mode !== 'commercial' && mode !== 'neutral') return;
    root.setAttribute('data-audience', mode);
    persist('mbn_audience', mode);
    document.querySelectorAll('[data-mbn-set-audience]').forEach(function (el) {
      el.setAttribute('aria-pressed', String(el.getAttribute('data-mbn-set-audience') === mode));
    });
    document.dispatchEvent(new CustomEvent('mbn:audience', { detail: { mode: mode } }));
  }

  /* -- VAT emphasis ------------------------------------------------------- */
  /* Both figures are server-rendered. This flips a class, nothing more —
     no recalculation, no flash of the wrong price. */
  function setVat(mode) {
    if (mode !== 'ex' && mode !== 'inc') return;
    root.classList.remove('vat-ex', 'vat-inc');
    root.classList.add('vat-' + mode);
    persist('mbn_vat', mode);
    document.querySelectorAll('[data-mbn-set-vat]').forEach(function (el) {
      el.setAttribute('aria-pressed', String(el.getAttribute('data-mbn-set-vat') === mode));
    });
  }

  /* Sync the toggles to the mode that boot already applied, so the selected
     state is announced correctly on first load and not only after a click. */
  (function syncToggles() {
    var mode = root.getAttribute('data-audience') || 'residential';
    document.querySelectorAll('[data-mbn-set-audience]').forEach(function (el) {
      el.setAttribute('aria-pressed', String(el.getAttribute('data-mbn-set-audience') === mode));
    });
    var vat = root.classList.contains('vat-inc') ? 'inc' : 'ex';
    document.querySelectorAll('[data-mbn-set-vat]').forEach(function (el) {
      el.setAttribute('aria-pressed', String(el.getAttribute('data-mbn-set-vat') === vat));
    });
  })();

  /* -- delegated controls ------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var aud = e.target.closest('[data-mbn-set-audience]');
    if (aud) {
      /* Anchors carry a real href so they work without JS; only take over
         when JS is running and the target is an in-page mode switch. */
      if (aud.dataset.mbnNavigate !== 'true') e.preventDefault();
      setAudience(aud.getAttribute('data-mbn-set-audience'));
      return;
    }
    var vat = e.target.closest('[data-mbn-set-vat]');
    if (vat) {
      e.preventDefault();
      setVat(vat.getAttribute('data-mbn-set-vat'));
    }
  });

  /* -- live region for cart + filter announcements ------------------------ */
  var live = document.getElementById('mbn-live');
  function announce(msg) { if (live) live.textContent = msg; }

  /* -- quick add to basket ------------------------------------------------ */
  /* The form posts to /cart/add normally without JS. With JS we use the Cart
     AJAX API so the page does not reload. */
  document.addEventListener('submit', function (e) {
    var wrap = e.target.closest('[data-mbn-quick-add]');
    if (!wrap) return;
    var form = e.target;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (item) {
        announce((item.product_title || 'Item') + ' added to basket');
        document.dispatchEvent(new CustomEvent('mbn:cart:added', { detail: { item: item } }));
        return refreshCartCount();
      })
      .catch(function () {
        /* Fall back to a real navigation rather than failing silently. */
        form.submit();
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mbn-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('mbn:cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  /* -- announcement dismissal --------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mbn-dismiss-announce]')) return;
    var bar = document.querySelector('[data-mbn-announce]');
    if (bar) bar.hidden = true;
    persist('mbn_announce_dismissed', '1');
  });

  /* -- focus trap ---------------------------------------------------------- */
  /* Shared by the mobile menu now, and by the cart drawer and quote modal
     when those land. Handover 6.3: trap while open, return focus on close. */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,summary,[tabindex]:not([tabindex="-1"])';
  function trapFocus(container, opener) {
    function onKey(e) {
      if (e.key === 'Escape') { release(); return; }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        container.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function release() {
      document.removeEventListener('keydown', onKey);
      container.hidden = true;
      document.body.style.overflow = '';
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
      container.dispatchEvent(new CustomEvent('mbn:closed'));
    }
    document.addEventListener('keydown', onKey);
    container.__mbnRelease = release;
    var firstEl = container.querySelector(FOCUSABLE);
    if (firstEl) firstEl.focus();
  }

  /* -- mobile menu --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mbn-open-menu]');
    if (open) {
      var menu = document.getElementById('mbn-mobile-menu');
      if (!menu) return;
      menu.hidden = false;
      document.body.style.overflow = 'hidden';
      open.setAttribute('aria-expanded', 'true');
      trapFocus(menu, open);
      return;
    }
    var close = e.target.closest('[data-mbn-close-menu]');
    if (close) {
      var m = close.closest('[data-mbn-mobile-menu]');
      if (m && m.__mbnRelease) m.__mbnRelease();
    }
  });

  /* -- mega menu ----------------------------------------------------------- */
  /* CSS already opens the panel on :hover and :focus-within, so this works
     without JS. This adds explicit click/keyboard control on touch and for
     keyboard users, which hover alone cannot serve (handover 6.3). */
  function closeAllMega(except) {
    document.querySelectorAll('.mbn-nav__item--has-panel.is-open').forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var t = li.querySelector('[data-mbn-mega-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mbn-mega-trigger]');
    if (!trigger) { closeAllMega(null); return; }
    /* Only hijack the click where the panel is actually the useful action —
       on a coarse pointer the link itself is still reachable by tapping the
       panel's own "All ..." entry. */
    if (!window.matchMedia('(hover: none)').matches) return;
    var li = trigger.closest('.mbn-nav__item--has-panel');
    if (!li) return;
    var isOpen = li.classList.contains('is-open');
    e.preventDefault();
    closeAllMega(li);
    li.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.mbn-nav__item--has-panel.is-open');
    if (open) {
      var t = open.querySelector('[data-mbn-mega-trigger]');
      closeAllMega(null);
      if (t) t.focus();
    }
  });

  /* ==========================================================================
     CART DRAWER
     Every mutation re-renders the section through the Section Rendering API,
     so all prices and VAT figures keep coming from Liquid. Nothing about the
     money in this drawer is computed in JavaScript.
     ======================================================================== */
  var SECTION_ID = 'mbn-cart-drawer';
  var cartOpener = null;

  function drawerEl() { return document.getElementById('mbn-cart-drawer'); }

  function openCart(opener) {
    var d = drawerEl();
    if (!d) return false;
    cartOpener = opener || null;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    trapFocus(d, cartOpener);
    return true;
  }
  function closeCart() {
    var d = drawerEl();
    if (d && d.__mbnRelease) d.__mbnRelease();
  }

  function renderCart() {
    return fetch(window.Shopify.routes.root + '?sections=' + SECTION_ID, {
      headers: { Accept: 'application/json' }, cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        /* Be defensive about the key: static sections key on the file name,
           but take whatever single key came back rather than assuming. */
        var html = data[SECTION_ID];
        if (html == null) {
          var keys = Object.keys(data);
          if (!keys.length) return;
          html = data[keys[0]];
        }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-mbn-cart-drawer]');
        var current = drawerEl();
        if (!fresh || !current) return;
        var wasOpen = !current.hidden;
        current.innerHTML = fresh.innerHTML;
        current.hidden = !wasOpen;
        document.dispatchEvent(new CustomEvent('mbn:stock:rendered'));
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mbn-open-cart]');
    if (open) {
      /* The basket control is a real link to /cart. Only take it over when the
         drawer is actually present, so no-JS and failure both fall through to
         the cart page. */
      if (openCart(open)) { e.preventDefault(); repairKingsleyCart(false); }
      return;
    }
    if (e.target.closest('[data-mbn-close-cart]')) { closeCart(); return; }

    var remove = e.target.closest('[data-mbn-remove-line]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-mbn-remove-line'), 0, remove.closest('.mbn-drawer__item'), remove.getAttribute('data-mbn-line-key'));
    }
  });

  /* Open the drawer once an add-to-basket has actually succeeded. */
  document.addEventListener('mbn:cart:added', function () {
    renderCart().then(function () { openCart(null); });
  });

  /* A basket left holding ONLY delivery-charge lines (the products they
     belonged to were removed) drops those charges too. */
  function isKingsleyCharge(item) {
    return Boolean(item.properties && item.properties._kingsley_delivery) || /^mbn-kingsley-delivery-/.test(item.handle || '');
  }

  function orphanUpdates(cart) {
    var items = cart.items || [];
    var updates = {};
    items.forEach(function (item) {
      if (!isKingsleyCharge(item)) return;
      var pair = item.properties && item.properties._kingsley_pair;
      var cabinet = pair && items.some(function (other) {
        return !isKingsleyCharge(other) && other.properties && other.properties._kingsley_cabinet && other.properties._kingsley_pair === pair;
      });
      if (!cabinet) updates[item.key] = 0;
    });
    if (items.length && items.every(function (item) { return item.properties && item.properties._mbn_addon; })) {
      items.forEach(function (item) { updates[item.key] = 0; });
    }
    return updates;
  }

  function removalUpdates(cart, item) {
    var updates = {};
    var pair = item.properties && item.properties._kingsley_pair;
    cart.items.forEach(function (other) {
      if (other.key === item.key || (pair && other.properties && other.properties._kingsley_pair === pair)) updates[other.key] = 0;
    });
    return updates;
  }

  function cartRequest(path, body) {
    var options = { headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(window.Shopify.routes.root + path, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || 'Basket update failed');
        return data;
      });
    });
  }

  function dropOrphanAddons(cart) {
    var updates = orphanUpdates(cart);
    return Object.keys(updates).length ? cartRequest('cart/update.js', { updates: updates }) : Promise.resolve(cart);
  }

  var cartBusy = false;
  function repairKingsleyCart(cartPage) {
    if (cartBusy) return Promise.resolve();
    cartBusy = true;
    return cartRequest('cart.js').then(function (cart) {
      var changed = Object.keys(orphanUpdates(cart)).length > 0;
      return dropOrphanAddons(cart).then(function () {
        if (cartPage && changed) { window.location.reload(); return; }
        return Promise.all([renderCart(), refreshCartCount()]);
      });
    }).catch(function () {
      announce('Could not update your basket. Open the basket page and try again.');
    }).finally(function () { cartBusy = false; });
  }

  function changeLine(line, quantity, itemEl, key) {
    if (cartBusy) return Promise.resolve();
    cartBusy = true;
    var qtyWrap = itemEl ? itemEl.querySelector('[data-mbn-qty]') : null;
    if (qtyWrap) qtyWrap.setAttribute('data-busy', '');
    key = key || (itemEl && itemEl.getAttribute('data-mbn-line-key'));
    var cartPage = itemEl && itemEl.closest('.mbn-cartpage');
    return cartRequest('cart.js').then(function (cart) {
      var item = key ? cart.items.find(function (it) { return it.key === key; }) : cart.items[Number(line) - 1];
      if (!item) return cart;
      if (Number(quantity) === 0) return cartRequest('cart/update.js', { updates: removalUpdates(cart, item) });
      if (item.properties && item.properties._kingsley_pair) return cart;
      return cartRequest('cart/change.js', { id: item.key, quantity: Number(quantity) });
    }).then(dropOrphanAddons).then(function (cart) {
      announce('Basket updated, ' + cart.item_count + ' items');
      if (cartPage) { window.location.reload(); return; }
      return Promise.all([renderCart(), refreshCartCount()]);
    }).catch(function () {
      announce('Could not update your basket. Please open the basket page and try again.');
      if (!cartPage) window.location.assign(window.Shopify.routes.root + 'cart');
    }).finally(function () {
      cartBusy = false;
      if (qtyWrap) qtyWrap.removeAttribute('data-busy');
    });
  }

  if (document.querySelector('.mbn-cartpage')) repairKingsleyCart(true);

  var qtyTimer = null;
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-mbn-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-mbn-qty]');
    var input = wrap && wrap.querySelector('.mbn-qty__input');
    if (!input) return;
    var min = Number(input.getAttribute('min') || 1);
    var next = Math.max(min, Number(input.value || min) + Number(step.getAttribute('data-mbn-qty-step')));
    if (next === Number(input.value)) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.mbn-qty__input');
    if (!input) return;
    var line = input.getAttribute('data-mbn-line');
    if (!line) return;
    clearTimeout(qtyTimer);
    if (input.closest('.mbn-cartpage')) {
      qtyTimer = setTimeout(function () { input.form.requestSubmit(input.form.querySelector('[name="update"]')); }, 250);
      return;
    }
    var itemEl = input.closest('.mbn-drawer__item');
    qtyTimer = setTimeout(function () {
      changeLine(line, input.value, itemEl);
    }, 250);
  });

  /* ==========================================================================
     PRODUCT PAGE
     ======================================================================== */

  /* -- gallery thumbs ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-mbn-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var hero = document.getElementById('mbn-hero-img');
    if (!hero) return;
    hero.src = thumb.getAttribute('data-full');
    hero.srcset = thumb.getAttribute('data-srcset') || '';
    document.querySelectorAll('[data-mbn-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* -- variant switching --------------------------------------------------- */
  /* Must navigate with ?variant=<id>. ?option1= is not resolved server-side. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-mbn-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var url = opt && opt.getAttribute('data-url');
    if (url) window.location.href = url;
  });

  /* -- quantity presets ---------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var preset = e.target.closest('[data-mbn-qty-preset]');
    if (!preset) return;
    var input = document.getElementById('mbn-product-qty');
    if (!input) return;
    input.value = preset.getAttribute('data-mbn-qty-preset');
    input.dispatchEvent(new Event('change', { bubbles: true }));
    preset.parentElement.querySelectorAll('[data-mbn-qty-preset]').forEach(function (b) {
      b.classList.toggle('is-active', b === preset);
    });
  });

  /* -- sticky add-to-basket bar -------------------------------------------- */
  /* Revealed only once the real CTA has scrolled out of view. Left hidden
     entirely without JS, where it could not be dismissed. */
  var buybox = document.querySelector('[data-mbn-buybox]');
  var stickybar = document.querySelector('[data-mbn-sticky-atc]');
  if (buybox && stickybar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickybar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(buybox);
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mbn-sticky-add]')) return;
    var form = document.querySelector('[data-mbn-product-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  /* Route the main product form through the Cart AJAX API too.

     Delivery options (the Kingsley pattern): each [data-mbn-addon] select
     records its choice as a line item property on the main product — that
     part works without any of this script. When the chosen option carries a
     data-addon-variant (a hidden surcharge product), the add switches to the
     JSON items form of /cart/add.js so the surcharge lands in the basket in
     the same request. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-mbn-product-form]');
    if (!form) return;
    if (!form.reportValidity()) { e.preventDefault(); return; }
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    /* What does each delivery-option select want the basket to contain?
       data-addon-variant-id on the select names the charge SKU either way;
       the chosen option carries data-addon-variant only when it needs it. */
    var addons = [];
    form.querySelectorAll('[data-mbn-addon]').forEach(function (sel) {
      var vid = parseInt(sel.getAttribute('data-addon-variant-id') || '', 10);
      if (!vid) return;
      var opt = sel.options[sel.selectedIndex];
      addons.push({ id: vid, wanted: !!(opt && opt.hasAttribute('data-addon-variant')) });
    });

    var req;
    if (addons.length) {
      /* Read the basket first: a charge already in it stays at qty 1 (never
         doubled by a second add), and an active "No" removes it. */
      req = fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = {};
          cart.items.forEach(function (it) { inCart[it.variant_id] = true; });

          var fd = new FormData(form);
          var main = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1, properties: {} };
          fd.forEach(function (v, k) {
            var m = /^properties\[(.+)\]$/.exec(k);
            if (m && v) main.properties[m[1]] = v;
          });

          var items = [main];
          var removals = {};
          addons.forEach(function (a) {
            if (a.wanted && !inCart[a.id]) {
              /* The _ prefix keeps the marker off the checkout page; it tags
                 the line as a delivery charge so an orphaned one can be
                 dropped when the products it belonged to are removed. */
              items.push({ id: a.id, quantity: 1, properties: { _mbn_addon: 'delivery-charge' } });
            } else if (!a.wanted && inCart[a.id]) {
              removals[a.id] = 0;
            }
          });

          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
            .then(function (data) {
              var added = (data.items && data.items[0]) || data;
              if (!Object.keys(removals).length) return added;
              return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ updates: removals })
              }).then(function () { return added; });
            });
        });
    } else {
      req = fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams(new FormData(form)).toString()
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }

    req
      .then(function (item) {
        announce((item.product_title || 'Item') + ' added to basket');
        document.dispatchEvent(new CustomEvent('mbn:cart:added', { detail: { item: item } }));
        return refreshCartCount();
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ==========================================================================
     SPARES MODULE
     ======================================================================== */
  var sparesRoot = document.querySelector('[data-mbn-spares]');
  if (sparesRoot) {
    var money = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: sparesRoot.getAttribute('data-currency') || 'GBP'
    });

    function selectedSpares() {
      return Array.prototype.filter.call(
        sparesRoot.querySelectorAll('[data-mbn-spare-pick]'),
        function (cb) { return cb.checked && !cb.closest('[data-mbn-spare]').hidden; }
      );
    }

    function syncBar() {
      var picked = selectedSpares();
      var bar = sparesRoot.querySelector('[data-mbn-spares-bar]');
      if (!bar) return;
      bar.hidden = picked.length === 0;
      var totalEx = 0;
      picked.forEach(function (cb) {
        /* Summing server-rendered ex-VAT pence. No VAT is computed here. */
        totalEx += Number(cb.closest('[data-mbn-spare]').getAttribute('data-ex') || 0);
      });
      var countEl = sparesRoot.querySelector('[data-mbn-spares-count]');
      var totalEl = sparesRoot.querySelector('[data-mbn-spares-total-ex]');
      if (countEl) countEl.textContent = picked.length + ' selected';
      if (totalEl) totalEl.textContent = money.format(totalEx / 100);
    }

    sparesRoot.addEventListener('change', function (e) {
      if (e.target.closest('[data-mbn-spare-pick]')) syncBar();
    });

    /* Filter pills — values come from the parts actually linked, never a
       hardcoded list, so a pill can never filter to nothing. */
    sparesRoot.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-mbn-spare-filter]');
      if (!pill) return;
      var want = pill.getAttribute('data-mbn-spare-filter');
      sparesRoot.querySelectorAll('[data-mbn-spare-filter]').forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', String(on));
      });
      sparesRoot.querySelectorAll('[data-mbn-spare]').forEach(function (row) {
        row.hidden = want !== 'all' && row.getAttribute('data-type') !== want;
      });
      syncBar();
    });

    sparesRoot.addEventListener('click', function (e) {
      var add = e.target.closest('[data-mbn-spares-add]');
      if (!add) return;
      var picked = selectedSpares();
      if (!picked.length) return;
      add.disabled = true;
      var label = add.textContent;
      add.textContent = 'Adding';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: picked.map(function (cb) { return { id: Number(cb.value), quantity: 1 }; })
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          announce(picked.length + ' parts added to basket');
          picked.forEach(function (cb) { cb.checked = false; });
          syncBar();
          document.dispatchEvent(new CustomEvent('mbn:cart:added', { detail: {} }));
          return refreshCartCount();
        })
        .catch(function () { announce('Could not add those parts. Please try again.'); })
        .then(function () { add.disabled = false; add.textContent = label; });
    });
  }

  /* ==========================================================================
     COLLECTION — filtering, sort, view, compare
     ======================================================================== */

  function collectionRoot() { return document.querySelector('[data-mbn-collection]'); }

  /* Swap only the collection section. The Section Rendering API keys on the
     section's id in the JSON template, not its type — the wrapper prints it. */
  function applyFilters(params, push) {
    var root = collectionRoot();
    if (!root) return;
    var sectionId = root.getAttribute('data-mbn-section-id');
    var qs = params.toString();
    var base = window.location.pathname;

    root.setAttribute('aria-busy', 'true');
    fetch(base + '?section_id=' + encodeURIComponent(sectionId) + (qs ? '&' + qs : ''), {
      headers: { Accept: 'text/html' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-mbn-collection]');
        var current = collectionRoot();
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
        current.setAttribute('data-audience', fresh.getAttribute('data-audience') || '');
        /* The swap re-renders the grid at the server default; put the
           visitor's remembered view back. (Hoisted from the view module.) */
        var v = storedView();
        if (v === 'list' || v === 'grid') applyView(v);
        if (push !== false) {
          window.history.pushState({}, '', base + (qs ? '?' + qs : ''));
        }
        var count = current.querySelector('[data-mbn-result-count]');
        if (count) announce(count.textContent.trim());
      })
      .catch(function () {
        /* Fall back to a real navigation so the user still gets their filter. */
        window.location.href = base + (qs ? '?' + qs : '');
      })
      .then(function () {
        var c = collectionRoot();
        if (c) c.removeAttribute('aria-busy');
      });
  }

  function paramsFromFilterForm(form) {
    var params = new URLSearchParams(new FormData(form));
    /* Drop empties so the URL stays clean and shareable. */
    Array.from(params.keys()).forEach(function (k) {
      if (!params.get(k)) params.delete(k);
    });
    return params;
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-mbn-filter-form]');
    if (form) { applyFilters(paramsFromFilterForm(form)); return; }

    var sortSel = e.target.closest('[data-mbn-sort]');
    if (sortSel) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSel.value);
      applyFilters(params);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-mbn-filter-form]');
    if (!form) return;
    e.preventDefault();
    applyFilters(paramsFromFilterForm(form));
  });

  document.addEventListener('click', function (e) {
    /* Clear-all and pagination stay real links; intercept for a live swap. */
    var clear = e.target.closest('.mbn-filters__clear');
    if (clear) { e.preventDefault(); applyFilters(new URLSearchParams()); return; }

    var page = e.target.closest('.mbn-pagination a');
    if (page) {
      e.preventDefault();
      var u = new URL(page.href, window.location.origin);
      applyFilters(new URLSearchParams(u.search));
      window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }
  });

  window.addEventListener('popstate', function () {
    if (collectionRoot()) applyFilters(new URLSearchParams(window.location.search), false);
  });

  /* -- view switch --------------------------------------------------------- */
  /* Grid is the server default for every new visitor; only an ACTIVE choice
     is remembered here and re-applied on later collection pages. */
  function applyView(want) {
    var grid = document.querySelector('[data-mbn-grid]');
    if (grid) grid.classList.toggle('mbn-grid--list', want === 'list');
    document.querySelectorAll('[data-mbn-view]').forEach(function (b) {
      var on = b.getAttribute('data-mbn-view') === want;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
  }

  function storedView() {
    try { return window.localStorage.getItem('mbn_view'); } catch (e) { return null; }
  }

  document.addEventListener('click', function (e) {
    var vbtn = e.target.closest('[data-mbn-view]');
    if (!vbtn) return;
    var want = vbtn.getAttribute('data-mbn-view');
    applyView(want);
    persist('mbn_view', want);
  });

  var initialView = storedView();
  if (initialView === 'list' || initialView === 'grid') applyView(initialView);

  /* ==========================================================================
     COMPARE  (commercial only, up to 4)
     Columns are fetched per product as a rendered section, so the spec values
     come from the same Liquid as the product page's spec table.
     ======================================================================== */
  var COMPARE_MAX = 4;
  var compare = [];

  function syncCompareBar() {
    var bar = document.querySelector('[data-mbn-compare-bar]');
    if (!bar) return;
    bar.hidden = compare.length === 0;
    var count = bar.querySelector('[data-mbn-compare-count]');
    var chips = bar.querySelector('[data-mbn-compare-chips]');
    if (count) count.textContent = compare.length + ' of ' + COMPARE_MAX + ' selected';
    if (chips) {
      chips.innerHTML = '';
      compare.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item.title;
        chips.appendChild(li);
      });
    }
    /* Stop over-selection at the source rather than erroring after the fact. */
    document.querySelectorAll('[data-mbn-compare-pick]').forEach(function (cb) {
      cb.disabled = !cb.checked && compare.length >= COMPARE_MAX;
    });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-mbn-compare-pick]');
    if (!cb) return;
    var handle = cb.value;
    if (cb.checked) {
      if (compare.length >= COMPARE_MAX) { cb.checked = false; return; }
      compare.push({ handle: handle, title: cb.getAttribute('data-title') || handle });
    } else {
      compare = compare.filter(function (i) { return i.handle !== handle; });
    }
    syncCompareBar();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mbn-compare-clear]')) {
      compare = [];
      document.querySelectorAll('[data-mbn-compare-pick]').forEach(function (cb) { cb.checked = false; });
      syncCompareBar();
      return;
    }
    if (e.target.closest('[data-mbn-compare-close]')) {
      var panel = document.querySelector('[data-mbn-compare-panel]');
      if (panel && panel.__mbnRelease) panel.__mbnRelease();
      return;
    }
    if (!e.target.closest('[data-mbn-compare-open]')) return;

    var p = document.querySelector('[data-mbn-compare-panel]');
    var body = p && p.querySelector('[data-mbn-compare-body]');
    if (!p || !body || !compare.length) return;
    p.hidden = false;
    document.body.style.overflow = 'hidden';
    trapFocus(p, null);
    body.innerHTML = '<p class="mbn-spec">Loading…</p>';

    Promise.all(compare.map(function (item) {
      return fetch(window.Shopify.routes.root + 'products/' + item.handle + '?section_id=mbn-compare-row', {
        headers: { Accept: 'text/html' }
      })
        .then(function (r) { return r.text(); })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var wrap = document.createElement('div');
      wrap.className = 'mbn-compare__cols';
      chunks.forEach(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var col = parsed.querySelector('.mbn-compare__col');
        if (col) wrap.appendChild(col);
      });
      body.innerHTML = '';
      body.appendChild(
        wrap.children.length ? wrap : document.createTextNode('Could not load the comparison.')
      );
    });
  });

  /* ==========================================================================
     ARTICLE — table of contents and share
     ======================================================================== */
  var articleBody = document.querySelector('.mbn-article__body');
  var toc = document.querySelector('[data-mbn-toc]');
  if (articleBody && toc) {
    var list = toc.querySelector('[data-mbn-toc-list]');
    var heads = articleBody.querySelectorAll('h2');
    if (heads.length > 1 && list) {
      Array.prototype.forEach.call(heads, function (h, i) {
        if (!h.id) {
          h.id = 'section-' + (i + 1) + '-' +
            (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;

      /* Highlight the section currently in view. */
      if ('IntersectionObserver' in window) {
        var links = list.querySelectorAll('a');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (a) {
              a.classList.toggle('is-current', a.getAttribute('href') === '#' + e.target.id);
            });
          });
        }, { rootMargin: '-120px 0px -70% 0px' });
        Array.prototype.forEach.call(heads, function (h) { io.observe(h); });
      }
    }
    /* Fewer than two headings: no jump list worth showing, so it stays hidden. */
  }

  /* Native share on mobile, plain links everywhere else. No third-party widget. */
  var shareBtn = document.querySelector('[data-mbn-share-native]');
  if (shareBtn && navigator.share) {
    shareBtn.hidden = false;
    shareBtn.addEventListener('click', function () {
      navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
    });
  }

  /* -- quote form prefill --------------------------------------------------- */
  /* Liquid cannot read arbitrary query params on Shopify, so the product, code
     and quantity carried over from a product page are applied here. */
  (function () {
    var form = document.querySelector('[data-mbn-quote-form]');
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    var map = { product: 'product', code: 'code', qty: 'qty' };
    Object.keys(map).forEach(function (key) {
      var val = params.get(map[key]);
      if (!val) return;
      var field = form.querySelector('[data-mbn-prefill="' + key + '"]');
      if (field) field.value = val;
    });
  })();

  /* ==========================================================================
     PRODUCT TABS (design block 6)
     Without JS every panel renders stacked under its own heading; this
     upgrade hides all but one and shows the tab bar. The default tab flips
     by audience: commercial leads with specifications when present.
     ======================================================================== */
  document.querySelectorAll('[data-mbn-tabs]').forEach(function (root) {
    var bar = root.querySelector('.mbn-tabs__bar');
    var tabs = root.querySelectorAll('[data-mbn-tab]');
    var panels = root.querySelectorAll('[data-mbn-panel]');
    if (!bar || tabs.length < 2) return;

    function activate(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-mbn-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-mbn-panel') !== name;
      });
    }

    bar.hidden = false;
    root.classList.add('mbn-tabs--js');
    bar.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mbn-tab]');
      if (t) activate(t.getAttribute('data-mbn-tab'));
    });

    var aud = document.documentElement.getAttribute('data-audience');
    var first = 'description';
    if (aud === 'commercial' && root.querySelector('[data-mbn-panel="spec"]')) first = 'spec';
    if (!root.querySelector('[data-mbn-panel="' + first + '"]')) {
      first = panels[0] && panels[0].getAttribute('data-mbn-panel');
    }
    if (first) activate(first);
  });

  /* -- copy the product code ------------------------------------------------ */
  document.querySelectorAll('[data-mbn-copy]').forEach(function (btn) {
    if (!navigator.clipboard) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(btn.getAttribute('data-mbn-copy')).then(function () {
        var label = btn.textContent;
        btn.textContent = 'Copied';
        setTimeout(function () { btn.textContent = label; }, 1500);
      }).catch(function () {});
    });
  });

  /* Expose the minimum needed by later sections (cart drawer, filters). */
  window.MBN = {
    setAudience: setAudience,
    setVat: setVat,
    announce: announce,
    refreshCartCount: refreshCartCount,
    openCart: openCart,
    closeCart: closeCart,
    renderCart: renderCart,
    trapFocus: trapFocus
  };
})();

(function () {
  'use strict';
  function updateStockQuantities() {
    document.querySelectorAll('[data-mbn-stock-quantity]').forEach(function (el) {
      var d = el.dataset;
      var warehouse = Number(d.warehouse);
      var requested = Number(d.inCart);
      if (d.isCart !== 'true') {
        var root = el.closest('.mbn-product');
        var input = root && root.querySelector('[name="quantity"]');
        requested += Math.max(1, Number(input && input.value) || 1);
      }
      var extra = Math.max(0, requested - warehouse);
      var message = warehouse > 0
        ? (extra > 0 ? (d.canOrder === 'true' ? d.split : d.short) : d.held)
        : (d.canOrder === 'true' ? d.order : d.unavailable);
      el.textContent = message.replaceAll('[warehouse]', String(warehouse)).replaceAll('[extra]', String(extra));
    });
  }
  var controller;
  function refreshStock() {
    if (!document.querySelector('[data-mbn-availability]')) return;
    if (controller) controller.abort();
    controller = new AbortController();
    fetch(window.location.href, { cache: 'no-store', signal: controller.signal })
      .then(function (r) { if (!r.ok) throw new Error('stock'); return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        ['.mbn-product', '.mbn-cartpage'].forEach(function (selector) {
          var root = document.querySelector(selector);
          var source = fresh.querySelector(selector);
          if (!root || !source) return;
          root.querySelectorAll('[data-mbn-availability]').forEach(function (current) {
            var replacement = source.querySelector('[data-mbn-availability][data-variant-id="' + current.dataset.variantId + '"]');
            if (replacement) current.replaceWith(replacement.cloneNode(true));
          });
        });
        updateStockQuantities();
      })
      .catch(function () {});
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches('[name="quantity"]')) updateStockQuantities();
  });
  document.addEventListener('change', updateStockQuantities);
  document.addEventListener('mbn:stock:rendered', updateStockQuantities);
  document.addEventListener('mbn:cart:updated', refreshStock);
  window.addEventListener('focus', function () {
    refreshStock();
    var drawer = document.querySelector('[data-mbn-cart-drawer]');
    if (drawer && !drawer.hidden && window.MBN) window.MBN.renderCart();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshStock(); });
  updateStockQuantities();
})();
